import { Link } from "react-router-dom";
import { EOI_FORM_URL } from "../config";

export const EoiLink = ({ className, testid, children }) => {
  if (/^https?:\/\//.test(EOI_FORM_URL)) {
    return (
      <a href={EOI_FORM_URL} target="_blank" rel="noopener noreferrer" className={className} data-testid={testid}>
        {children}
      </a>
    );
  }
  return (
    <Link to={EOI_FORM_URL} className={className} data-testid={testid}>
      {children}
    </Link>
  );
};
